import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const r = await api.get("/audit?limit=200"); setItems(r.data); })(); }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow mb-2">Audit Trail</div>
        <h1 className="font-display text-4xl">Immutable activity log</h1>
        <p className="text-white/60 text-sm mt-2">Every write is recorded — GDPR Article 30 record of processing activities.</p>
      </div>
      <div className="glass rounded-xl overflow-hidden">
        {items.length === 0 ? (
          <div className="p-12 text-center text-white/50 text-sm">No events logged yet.</div>
        ) : (
          <table className="data">
            <thead><tr><th>Timestamp</th><th>Action</th><th>Entity</th><th>ID</th><th>Meta</th></tr></thead>
            <tbody>
              {items.map(a => (
                <tr key={a.audit_id}>
                  <td className="mono text-xs text-white/60">{a.timestamp?.slice(0, 19).replace("T", " ")}</td>
                  <td><span className="badge-pass px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider">{a.action}</span></td>
                  <td className="text-white/70">{a.entity}</td>
                  <td className="mono text-xs text-white/50">{a.entity_id}</td>
                  <td className="text-white/50 text-xs truncate max-w-xs">{JSON.stringify(a.meta || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
